"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForkRef = exports.setReactRef = void 0;
var react_1 = require("react");
/**
 * Set React.ref value whether it's a function or object ref
 */
exports.setReactRef = function (ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref && typeof ref === 'object') {
        // eslint-disable-next-line no-param-reassign
        ref.current = value;
    }
};
/**
 * Adapted from material-ui/blob/master/packages/material-ui/src/utils/useForkRef.js
 */
exports.useForkRef = function (ref1, ref2) {
    return react_1.useMemo(function () {
        if (ref1 == null && ref2 == null) {
            return null;
        }
        return function (refValue) {
            exports.setReactRef(ref1, refValue);
            exports.setReactRef(ref2, refValue);
        };
    }, [ref1, ref2]);
};
//# sourceMappingURL=setReactRef.js.map